<div class="m-quiz-socket-refresh">
    <h3>
        Connection with server was lost!
    </h3>
    <div class="row">
        <div class="col-12">Please, refresh this page</div>
    </div>
</div>